export function ScoreBar({ score, max = 1000 }) {
  const pct = Math.max(0, Math.min(100, (score / max) * 100));
  const color = score > 600 ? "#6fcf97" : score > 250 ? "#f0c040" : "#eb5757";
  return (
    <div style={{ height: 3, background: "#1a2535", borderRadius: 2, overflow: "hidden", marginTop: 4 }}>
      <div style={{ width: `${pct}%`, height: "100%", background: color, transition: "width 0.6s ease", borderRadius: 2 }} />
    </div>
  );
}
